import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { AnimateComponent } from '@app/components/animate/animate.component';

@Component({
  selector: 'app-rewards-section',
  templateUrl: './rewards-section.component.html',
  styleUrls: ['./rewards-section.component.scss'],
  standalone: true,
  imports: [NgOptimizedImage, AnimateComponent],
})
export class RewardsSectionComponent {}
